import styled from "styled-components";

export const StyledResult = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  padding: var(--spacing-md);
  color: var(--color-text);
  img {
    margin-bottom: var(--spacing-lg);
    width: 144px;
    height: 120px;
    object-fit: contain;
  }
  h2 {
    font-size: var(--font-size-xl);
    font-weight: 600;
    margin-bottom: var(--spacing-sm);
  }
  p {
    font-size: var(--font-size-md);
    font-weight: 400;
    margin-bottom: var(--spacing-lg);
  }
`;
